import React, { Component } from 'react';
import { Search, CartSummaryMenu, SvgImage, ImportCartPanel, BusyContainer, IconButton } from '../../../components';
import { logoIcon, profileIcon, uploadIcon, ABBLogo, menuIcon,Language, CartLogoNew, VectorCartLogoNew, VectorMobileSearchIcon, VectorMobileTreeViewIcon, arrowLeftIcon, ABBLogoSVG, GlobalIconNew, ProductMenuIconNew, OpenInNewWindow,support } from '../../../../style/images';
import { connect } from 'react-redux';
import { combineStates, identityState, siteSettingsState, popupDispatcher, mobileViewState, mobileViewDispatcher, combineDispatchers, mobilePageViewState, mobilePageViewDispatcher, searchState, searchDispatcher, flagState, flagDispatcher, showConfigureState, currentPageState, currentNodeState, screenSizeState, dialogDispatcher } from '../../../store';
import { configuratorActions, flagActions, importActions, sessionStore, superCodeActions, translate,getLanguages, productActions } from '../../../services';
import { UserMenu , RequestSupport,BreadcrumbHeader } from '.';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { AppBar, Box, Button, Dialog,Grid,ListItemButton, ListItemIcon, ListItemText, Paper, List, ListItem, Tab, Tabs, ToggleButton, ToggleButtonGroup, Toolbar, Typography, styled } from '@mui/material';
import { ABBRedLogo, ABBRedLogoPng } from '../../../../style/images';
import { Dataset, FormatListBulleted, GridViewSharp } from '@mui/icons-material';
import { IconButton as MuiIconButton,Modal } from '@material-ui/core';
import { TabList } from '@mui/lab';
import { Link } from 'react-router-dom/cjs/react-router-dom'; 
import { DetailedModal } from '../../../components/DetailedModal';
var inframe=false;
function iniFrame() {
  if ( window.location !== window.parent.location )
  {
   
      inframe=true;
  }
  else {
  
      inframe=false;
  }
}
iniFrame();
export class SiteHeaderComponent extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      userMenuActive: false,
      tab: "Categories",
      pageCounter:0,
      isSearchOn: false,
      isCartOn: false,
      showWelcome: false,
      showModal: false,
      showLinkDetails:false
    };
  }

  componentDidMount() {
    this.mounted = true;
    window.addEventListener('popstate', this.onBrowserBackPrev);
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener( 'popstate', this.onBrowserBackPrev );
  }
    onBrowserBackPrev = ()=>{
      if(!window.location.href.includes('#/cart')){
        this.setCartMobileView(false)
      }
      if(this.state.isSearchOn && this.props.screenSize.width<=900){ //in mobile on click of back hide searchbar
        this.setSearchMobileView(false)
        }
    }
  getActive( path ) {
    if (path.includes('support')) return 'support';
    if( !path.includes( 'cfg-solution-Configurators' ) && ( path.includes( 'categories' ) || path.includes( 'selector' ) ) ) {
      return 'categories';
    }

    if( path.includes( 'cfg-solution-Configurators' ) || path.includes( 'configurator' ) ) {
      return 'solutions';
    }

    return null;
  }

  hideUserMenu = event => {
    if( !this.usermenu || !event.relatedTarget || !this.usermenu.contains( event.relatedTarget ) ) {
      this.mounted && this.setState( { userMenuActive: false } );
    }
  }
  openImport = () => {
    // this.props.setPopup( { title: 'Import Cart', component: <ImportCartPanel />, showHeader: true, keepOpen: false } );
    this.props.showDialog( <ImportCartPanel onClose = {this.props.onClose} />)
  }

  setUserMenu = div => this.usermenu = div

  toggle = () => {
    const { userMenuActive } = this.state;
    this.mounted && this.setState( { userMenuActive: !userMenuActive } );
    if(this.props.flags.showSearchOverlay){
      this.props.hideSearchOverlay();
      }
  }
  dismissWelcomeMessage = () => {
    this.setState({ showWelcome: false });
  };
  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };
  handleTabChange = (event, newValue)=>{
    this.mounted && this.setState( { tab: newValue } );
  }

 handleAlignment = (event, newAlignment)=>{
    if(newAlignment==="listView"){
      this.props.listView();
    }
    else{
      this.props.mediaView();
    }
 }

 onBack = () =>{
  this.setCartMobileView(false);
  const {landingpagecart} = this.props;
  landingpagecart?window.location.href = '#/categories' : window.history.back();
 };

 setSearchMobileView = (flag) => {
    if(flag){
      this.props.showSearch();
      this.props.showMobileSearchHeader()
    }
    else{
      this.props.hideMobileSearchHeader()
    }
    this.setState({isSearchOn:flag})
    let element = document.getElementById("search")
    document.getElementById("search").focus();
  }

  setCartMobileView = (flag) => {
    if(this.props.screenSize.width<=900){
      if(flag){
        this.props.showCart(); 
      }
      else{
        this.props.showOther();
      }
      this.setState({isCartOn:flag})
    }
  }

  handleHome = ()=>{
    this.props.flags.search&&this.props.hideSearchText()
    if(this.props.flags.showSearchOverlay){
      this.props.hideSearchOverlay();
      }
  }

  getActions(currentPage){
    if(currentPage==="productPage"){
      return ['filter-active']
    }
    if(currentPage==="modelConfiguratorSelectorPage"){
      return [...Object.keys( configuratorActions ).map( key => configuratorActions[key] ), 'filter-active'];
    }
    if(currentPage==="detailedSearchPage"){
      return ['search-active', 'filter-active']
    }
    if(currentPage==="configuratorPage"){
      return [configuratorActions.ASSIGN,
        configuratorActions.RESET,
        configuratorActions.REMOVE,
        configuratorActions.LOADED,
        configuratorActions.FROMTEMPLATE,
        superCodeActions.CREATE,
        productActions.GET,
        productActions.LOAD,
        'search-active',
        'filter-active',
        flagActions.ADDING
      ]
    }
    if(currentPage==="modelConfiguratorPage"){
      return Object.keys( configuratorActions ).map( key => configuratorActions[key] );
    }
    if(currentPage==="accessoryConfiguratorPage"){
      return [configuratorActions.ASSIGN, configuratorActions.RESET, configuratorActions.REMOVE, configuratorActions.LOADED, 'filter-active']
    }
    if(currentPage==="categoriesPage"){
      return ['filter-active']
    }

    if(currentPage==="cartPage"){
      return ['filter-active',importActions.VALIDATE, superCodeActions.CREATE]
    }
    return []
  }
  toggleLinkDetails = ()=>{
    this.setState({showLinkDetails:!this.state.showLinkDetails})
  }
  openLink = (link)=>{
    if( Array.isArray(link.targetUrl) ) {
      const lang = getLanguages().first(); // current language selected
      const findTargetUrl = link.targetUrl.find(curLink => curLink.lang === lang )
      const targetUrl = findTargetUrl ? findTargetUrl.url : link.targetUrl[0].url
      window.open(targetUrl,'_blank')
    }else if(link.targetUrl.startsWith( '/' )){
      const root = window.location.href.split( '/#' )[0];
      const newLocation = `${root}/#${ link.targetUrl }`;
      window.location.href = newLocation;
    }else{
      window.open(link.targetUrl,'_blank')
    }
    this.toggleLinkDetails();    
  }
  render() {
    const { isIntegrated, path, siteSettings, user, view } = this.props;
    sessionStore.set("customercode", user.properties.CustomerCode);
    const { userMenuActive } = this.state;
    const active = this.getActive( path );
    const className = classNames( 'user-menu-panel', { 'active': userMenuActive } );

    // if(this.state.isSearchOn && this.props.mobileViewPage.showPage!=="search" && !window.location.href.includes("search")){
    //   this.props.showOther();
    //   this.setSearchMobileView(false)
    // }
    const NewTab = styled(Tab)({
      height: "17px", 
      fontStyle: "normal",
      fontWeight: '400',
      fontSize: "14px",
      lineHeight: "120%",                
      display: "flex-start",
      alignItems: "center",color:"#000000",
      "&.Mui-selected": {
        color:"#000000",
        fontWeight:"700",
      }
    })

    const StyledTypography = styled(Typography)({
      "&.Mui-selected": {
        color:'red',
        fontWeight:"700",
        fontSize:"16px"
      }
    });

    const outerLinks = siteSettings.configuration && siteSettings.configuration.navigationLinks
    .filter( link => link.isEnabled && !link.translationKey.includes('Catalog') ) 
    .map((link) => {return !link.targetUrl.startsWith( '/' )&&
    <a key={link.translationKey} value={link.translationKey} label={link.translationKey} href={link.targetUrl} target="_blank">
      <span className='links'>{translate(link.translationKey)}</span>
    </a>}
   );
   // to render catalogLink coming from siteSettings 
   const catalogLink = siteSettings.configuration && siteSettings.configuration.navigationLinks
    .filter( link => link.isEnabled && link.translationKey.includes('Catalog') ) 
    .map((link) => {    
    if( Array.isArray(link.targetUrl) ) {
      const lang = getLanguages().first(); // current language selected
       const findTargetUrl = link.targetUrl.find(curLink => curLink.lang === lang )
       const targetUrl = findTargetUrl ? findTargetUrl.url : link.targetUrl[0].url
        return <a key={link.translationKey} value={link.translationKey} label={link.translationKey} href={targetUrl} target="_blank">
        <span className='links'>{translate(link.translationKey)}</span>
      </a>;
    } else {
      return  <a key={link.translationKey} value={link.translationKey} label={link.translationKey} href={link.targetUrl} target="_blank">
         <span className='links'>{translate(link.translationKey)}</span>
       </a>
    }
    }
   );
   const showNotification= siteSettings.properties?.showNotification;
   const customLinks = siteSettings.configuration && siteSettings.configuration.navigationLinks
      .filter( link => link.isEnabled && !link.translationKey.includes('Catalog') ) 
      .map((link) => {return link.targetUrl.startsWith( '/' )?
      <Link key={link.translationKey} to={link.targetUrl} className={ active === link.translationKey.toLowerCase() ? 'active' : '' } onClick={ () => {
        if(this.props.flags.showSearchOverlay){
        this.props.hideSearchOverlay();
        }}
        }>
        <span class='links'>{translate(link.translationKey)}</span>
      </Link>:null  
     }
     );
     const mobileLinks = siteSettings.configuration && siteSettings.configuration.navigationLinks
     .filter(link => link.isEnabled)
     .map((link) => {
      const lstIcon = link.translationKey === "Support"?support:OpenInNewWindow;
         return (link.translationKey.includes('Catalog') || link.translationKey === "Support" || !link.targetUrl.startsWith( '/' )) && <ListItemButton className='list-items' onClick={() => this.openLink(link)}>
           <ListItemIcon className='listLinkIcon'>
             <img src={lstIcon} />
           </ListItemIcon>
           <ListItemText primary={translate(link.translationKey)} />
         </ListItemButton>
    }).filter(lnk=>lnk);
    const showCartSummeryMenu = user.authenticationType !== 'Cbol' ? user.useLocalCart && user.hasCart : false;
    const { showWelcome,showModal } = this.state;
    const configuratorAction =[configuratorActions.ASSIGN,
      configuratorActions.RESET,
      configuratorActions.REMOVE,
      configuratorActions.LOADED,
      configuratorActions.FROMTEMPLATE,
      superCodeActions.CREATE,
      'search-active',
      "filter-active"
    ]

    const productActions = ["filter-active"]

    let actions = this.getActions(this.props.currentPage.currentPage);
    return(
      <BusyContainer className={"site-header-container"} actions={actions} busy={this.props.flags.isBusy}>
        <Grid item xl={12} md={12} xs={12} sx={{height:{xl:"100%", md:"100%", xs:"80px"},display:{md:"block",xs:"block"}}}>
        <Box sx={{ display:{xl:"none", lg:"none", md:"none", xs:this.props.flags.mobileSearchHeader && !this.props.showConfigure.show?"flex":"none"},
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 16px",
                    height:"80px",
                    borderBottom: "1px solid var(--primary-color-grey-10, #EBEBEB)",
                    background: "#FFF"}}>
                      <Box sx={{display:"flex",width:"80%", flexDirection:'row', justifyContent:"center"}} onClick={()=>{this.setSearchMobileView(true)}}>
                        <Search searchString={ "" } setSearchMobileView={this.setSearchMobileView} mobile={true} setSearchString={this.props.setSearchString}/>
                      </Box>
                      <div className="red-button-text" onClick={()=>{
                        this.props.showOther();
                        this.setSearchMobileView(false)}}>{translate("Cancel")}</div> 
                  </Box>
            <Box sx={{ display:{xl:"none", lg:"none", md:"none", xs:this.props.mobileViewPage.showPage==="cart"|| this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage"?"flex":"none"},
                    alignItems: "center",
                    padding: "16px",
                    height:"80px",
                    gap:this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage" ?"16px" :"8px",
                    borderBottom:this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage"?"none": "1px solid var(--primary-color-grey-20, #DBDBDB)",
                    background: "#FFF"}}>
                      <div onClick={this.onBack} className="mobile-cart-back"><Box component="img" src={arrowLeftIcon} sx={{width:"16px", height:"16px"}}></Box></div>
                      <span className='cart-heading'style={{fontSize:this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage"?"14px":"18px", color:this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage"?"#0F0F0F":"#000"}}>{this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage"?translate(this.props.currentNode.name):translate('Cart')}</span>
                  </Box>
            <Box sx={{ display:{xl:"flex", lg:"flex", md:"flex", xs:this.props.flags.mobileSearchHeader||this.state.isCartOn||this.props.mobileViewPage.showPage==="cart"||this.props.currentPage.currentPage==="modelConfiguratorPage" || this.props.currentPage.currentPage==="modelConfiguratorSelectorPage"?"none":"flex"},
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    padding: {md:"0px 16px", xs: "24px 24px 24px 16px"},
                    left: "0px",
                    top: "0px",
                    bgcolor:'white',
                    height:{xl:"100%", md:"100%", xs:"80px"}}}>
                {!isIntegrated && <Link to="/" onClick={this.handleHome}>
                  <Box sx={{display:"flex", flexDirection:'row', justifyContent:"center"}} height="30px" onClick={this.props.resetSearch}>
                    <img src={ ABBLogoSVG } width="70px" height="27.67px"/>
                    <Box sx={{width:"1px", height:"24px", m:{md:"1px 24px 0px 24px", xs:"1px 8px 0px 8px"}, background:"#BABABA"}}></Box>
                    <span className="econfigure">{ translate( "eConfigure Devices" ) }</span>
                  </Box>
                </Link>}

                <Box sx={{flexGrow:1}}></Box>
                
                <Box sx={{display:"flex", flexDirection:'row', justifyContent: "center", alignItems:"center", height:"100%", gap:{md:"40px", xs:"16px"}}}>
                  
                  <Box width="100%" height="100%" sx={{display:{md:"flex", xs:"none"},justifyContent: "center", alignItems:"center",flexDirection:"row", gap:"40px"}}>
                    <div class='navLinks' style={{display:"flex", justifyContent:"center", alignItems:"center",flexDirection:"row", gap:"40px"}}>
                      { customLinks }    
                    </div>
                    {catalogLink}
                    {outerLinks}
                  </Box>
                  {inframe?<>
                      { isIntegrated &&<Box sx={{display:{xl:"flex", md:"flex", xs:"none"}, flexDirection:'row', justifyContent:"center"}}><Search searchString={ "" } setSearchString={this.props.setSearchString} /></Box>}
                      <Box sx={{width:"0px", height:"24px"}} border="1px solid #BABABA"></Box>
                      { isIntegrated && user && user.authenticationType==='Cbol' && siteSettings.importSettings.cbol && 
                      <><IconButton icon={ uploadIcon } text={ translate( 'Import' ) } onClick={ this.openImport } href="/cart" /> 
                      <Box sx={{width:"0px", height:"24px"}} border="1px solid #BABABA"></Box>
                      </>}
                      {
                        siteSettings.properties?.languageOptionVisible && isIntegrated && <>
                        <div ref={ this.setUserMenu } tabIndex="-1" className={ className } onBlur={ this.hideUserMenu }>
                        <img src= { Language  } style={{paddingTop:"12px",width:"25px",height:"30px",paddingRight:"10px"}} onClick={ this.toggle }/>
                        <UserMenu />
                      </div>  
                      <Box sx={{width:"0px", height:"24px"}} border="1px solid #BABABA"></Box>
                      </>
                    }
                    {/* <Box height="24px" width="0px" border="1px solid #BABABA"></Box> */}
                    { isIntegrated && user && showCartSummeryMenu && <CartSummaryMenu /> }
                    {/* { isIntegrated && user && showCartSummeryMenu &&
                      <Box
                        display='flex' 
                        sx={{height: "22.5px",width: 
                          "21px"}}
                      ><CartSummaryMenu /></Box>} */}
                </>:
                <>
                  {!isIntegrated &&<Box sx={{display:{xl:"flex", md:"flex", xs:"none"}, flexDirection:'row', justifyContent:"center"}}>
                    <Search searchString={ "" } mobileView={false} setSearchString={this.props.setSearchString}/>
                  </Box>  }
                  {/* { siteSettings.jiraSupport && <JiraSupport className = { className } />  } */}
                  {/* { user && siteSettings.showRequestButton &&  <RequestSupport className = { className } />  } */}
                  { isIntegrated && user && user.authenticationType==='Cbol' && siteSettings.importSettings.cbol && <IconButton icon={ uploadIcon } text={ translate( 'Import' ) } onClick={ this.openImport } href="/cart" /> }
                {
                    siteSettings.showUserMenu && !isIntegrated && this.props.screenSize.width>900 && <div ref={ this.setUserMenu } tabIndex="-1" className={ classNames('user-menu-panel', 'active')  }  style={{height:"48px"}}
                    //  onBlur={ this.hideUserMenu }
                     >
                      <Box component="img" sx={{width:{md:"48px", xs:"24px"}, height:"48px", background:this.state.userMenuActive?"var(--Primary-Color-Background-Tertiary-White, #F5F5F5)":"transparent",borderRadius:"56px", padding:{md:"12px", xs:"0px"}}} src={ GlobalIconNew } onClick={ this.toggle }/>
                      <Dialog className='Profile' hideBackdrop={true} open={this.state.userMenuActive} onClose={this.toggle} PaperProps={{sx:{
                        position: "absolute",
                        top: "auto",
                        width:"max-content",
                        height:"max-content",
                        margin:"0px",
                        overflow:"unset",
                      }}}>
                        <UserMenu />
                      </Dialog>
                      </div>  
                  }
                   {
        }
                  <Box sx={{display:{lg:"none", md:"none", xs:"flex"}}}>
                    <MuiIconButton style={{padding: '0px'}} onClick={()=>{this.setSearchMobileView(true)}}>
                          <Box component="img" width="24px" height="24px" src={VectorMobileSearchIcon}></Box> 
                    </MuiIconButton>
                  </Box>
                  {!isIntegrated && user && user.useLocalCart && user.hasCart &&
                  <><Box height="24px" width="0px" border="1px solid #BABABA" sx={{display:{md:"flex", xs:"none"}}}></Box>
                  <CartSummaryMenu mobileView setCartMobileView={this.setCartMobileView}></CartSummaryMenu></>}
                  {mobileLinks && mobileLinks.length > 0 && <Box sx={{display:{lg:"none", md:"none", xs:"flex"}}}>
                    <MuiIconButton style={{padding: '0px'}} onClick={this.toggleLinkDetails}>
                          <Box component="img" width="24px" height="24px" src={ProductMenuIconNew}></Box> 
                    </MuiIconButton>
                  </Box>}
                  <DetailedModal item={mobileLinks} showMobileLinkContainer showItemDetails={this.state.showLinkDetails} toogleItemDetail={()=>{this.toggleLinkDetails()}}></DetailedModal>
                  </>
                }
                </Box>
            </Box>  
        </Grid>
        
      </BusyContainer>
      )
  }
}

SiteHeaderComponent.propTypes = {
  isIntegrated: PropTypes.bool,
  siteSettings: PropTypes.shape( {
    configuration: PropTypes.shape( {
      navigationLinks: PropTypes.arrayOf( PropTypes.shape( {
        isEnabled: PropTypes.bool,
        targetUrl: PropTypes.string,
        translationKey: PropTypes.string
      } ) )
    } ),
    showUserMenu: PropTypes.bool.isRequired
  } ),
  user: PropTypes.shape( {
    hasCart: PropTypes.bool.isRequired,
    useLocalCart: PropTypes.bool.isRequired,
    properties: PropTypes.shape( {
      DisplayName: PropTypes.string.isRequired
    }).isRequired
  } ),
  setPopup: PropTypes.func.isRequired,
};

export const SiteHeader = connect( combineStates(searchState,currentNodeState, identityState, siteSettingsState, mobileViewState, mobilePageViewState, flagState, showConfigureState, currentPageState, screenSizeState, flagState ), combineDispatchers(popupDispatcher, mobileViewDispatcher, mobilePageViewDispatcher, searchDispatcher, flagDispatcher, dialogDispatcher) )( SiteHeaderComponent );
